import { useMemo } from "react";

import { useSportEventsNewList, QueryOptions } from "./sportEventsNewList";

// Common query options shared by both sports (everything except `sportType`).
type CommonOptions = Omit<QueryOptions, "sportType">;

// Aggregate feed for the surfaces that show football AND basketball together
// (home "Maç Akışı", "Starting Soon"). The list query takes a single sport, so
// fetch both and merge — football first. Extracted so the two callers don't
// duplicate the merge (Principle 6).
export const useFootballAndBasketballEvents = (
  commonOptions: CommonOptions
) => {
  const footballQuery = useSportEventsNewList({
    queryOptions: { ...commonOptions, sportType: "football" },
  });
  const basketballQuery = useSportEventsNewList({
    queryOptions: { ...commonOptions, sportType: "basketball" },
  });

  const events = useMemo(
    () => [...(footballQuery.data ?? []), ...(basketballQuery.data ?? [])],
    [footballQuery.data, basketballQuery.data]
  );

  return {
    events,
    isLoading: footballQuery.isLoading || basketballQuery.isLoading,
  };
};
